import { BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';
import { getNotificationMessage } from 'customHelpersPath/paymentHistoryTradeline.helper';
const { ALL, TRANS_UNION, EXPERIAN, EQUIFAX } = BUREAU_ENUMS;

export const parseTradeline = (
  tradeline,
  bureau = ALL,
  eventHandler,
  history,
) => {
  const transUnionBureauAnnotation = () => {
    if (bureau === ALL) {
      return tradeline?.bureauAnnotation?.transUnion;
    } else if (bureau === TRANS_UNION) {
      return tradeline?.annotation;
    } else {
      return null;
    }
  };
  const equifaxBureauAnnotation = () => {
    if (bureau === ALL) {
      return tradeline?.bureauAnnotation?.equifax;
    } else if (bureau === EQUIFAX) {
      return tradeline?.annotation;
    } else {
      return null;
    }
  };
  const experianBureauAnnotation = () => {
    if (bureau === ALL) {
      return tradeline?.bureauAnnotation?.experian;
    } else if (bureau === EXPERIAN) {
      return tradeline?.annotation;
    } else {
      return null;
    }
  };

  const getDefaultAnnotation = () => {
    if (bureau === ALL) {
      return transUnionBureauAnnotation();
    } else {
      return tradeline?.annotation;
    }
  };
  const getBgNotification = () => {
    if (
      getDefaultAnnotation()?.paymentHistory?.delinquentTradelineToCurrent ||
      getDefaultAnnotation()?.paymentHistory?.paymentStreak
    ) {
      return 'system_success_s025';
    } else {
      return 'system_error_e025';
    }
  };

  const notificationMessage = getNotificationMessage({
    getDefaultAnnotation,
    tradeline,
    eventHandler,
    history,
  });

  const parsedTradeline = {
    creditor: tradeline?.creditor,
    grantedTradeAccountType: tradeline?.grantedTradeAccountType,
    dueAmount:
      tradeline?.amountPastDue > 0
        ? 'Past due: $' + tradeline?.amountPastDue?.toLocaleString()
        : 'Due: $' + tradeline?.currentBalance?.toLocaleString(),
    payStatus: tradeline?.payStatus,
    transunion: {
      status:
        bureau === ALL
          ? tradeline?.bureauPayStatus?.transUnion
          : bureau === TRANS_UNION
          ? tradeline?.payStatuses
          : {},
      annotation: {
        current:
          transUnionBureauAnnotation()?.paymentHistory
            ?.delinquentTradelineToCurrent ||
          transUnionBureauAnnotation()?.paymentHistory?.paymentStreak,
        delinquent: transUnionBureauAnnotation()?.delinquent,
        derogatory:
          transUnionBureauAnnotation()?.derogatory &&
          !transUnionBureauAnnotation()?.delinquent,
      },
    },
    equifax: {
      status:
        bureau === ALL
          ? tradeline?.bureauPayStatus?.equifax
          : bureau === EQUIFAX
          ? tradeline?.payStatuses
          : {},
      annotation: {
        current:
          equifaxBureauAnnotation()?.paymentHistory
            ?.delinquentTradelineToCurrent ||
          equifaxBureauAnnotation()?.paymentHistory?.paymentStreak,
        delinquent: equifaxBureauAnnotation()?.delinquent,
        derogatory:
          equifaxBureauAnnotation()?.derogatory &&
          !equifaxBureauAnnotation()?.delinquent,
      },
    },
    experian: {
      status:
        bureau === ALL
          ? tradeline?.bureauPayStatus?.experian
          : bureau === EXPERIAN
          ? tradeline?.payStatuses
          : {},
      annotation: {
        current:
          experianBureauAnnotation()?.paymentHistory
            ?.delinquentTradelineToCurrent ||
          experianBureauAnnotation()?.paymentHistory?.paymentStreak,
        delinquent: experianBureauAnnotation()?.delinquent,
        derogatory:
          experianBureauAnnotation()?.derogatory &&
          !experianBureauAnnotation()?.delinquent,
      },
    },
    bgNotification: getBgNotification(),
    notificationMessage,
    defaultAnnotation: getDefaultAnnotation(),
  };
  return parsedTradeline;
};
